import React from "react";
import { PanelAddSlider } from "../../../UI/Sliders/Add/PanelAddSlider";

const AddSlider = () => {
  return (
    <div>
      <PanelAddSlider />
    </div>
  );
};

export default AddSlider;
